exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:block}:host button{display:block;background:url(" + require("../../../../content/images/FC.svg") + ") no-repeat 50%;background-size:contain;height:100px;width:100%;border:1px solid #005092}:host button,:host p{max-width:32rem;margin:auto}:host p{margin-top:10px;color:#767676;font-size:14px;line-height:24px}:host p a{color:#767676;text-decoration:underline;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/franceConnect-button/franceConnect-button.component.scss
// module id = 741
// module chunks = 0